import { Divider, Grid, Tab, Tabs } from "@material-ui/core";
import { useCollection, useOnSubmitFormik, useThemeBreakpoints } from "api";
import {
    Championship,
    ChampionshipDefaultValues,
    Collections,
} from "api/model";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { Prompt, useHistory, useParams } from "react-router";
import {
    Message,
    BoxCard,
    PageLayout,
    SubmitButton,
    yupRequiredField,
} from "ui/componentes";
import {
    DriverConfiguration,
    RaceConfigurationList,
    RoundList,
} from "ui/views";
import { ChampionshipDetails } from "ui/views/ChampionshipForm/ChampionshipDetails";
import { ChampionshipCars } from "ui/views/ChampionshipForm/ChampionshipCars";
import { FixedBottomBar } from "ui/componentes/FixedBottomBar/FixedBottomBar";
import { ChampionshipPointingForm } from "ui/views/ChampionshipForm/ChampionshipPointingForm";
import * as Yup from "yup";

const ChampionshipValidation = Yup.object<Championship>().shape({
    seasonId: Yup.string().required(yupRequiredField),
    name: Yup.string().required(yupRequiredField),
});

const selectTab = (setSelectedTab) => (event, value) => {
    setSelectedTab(value);
};

const ChampionshipForm = () => {
    const { id } = useParams<{ id }>();
    const history = useHistory();
    const [selectedTab, setSelectedTab] = useState("details");

    const championship: Championship =
        useCollection<Championship>({
            collection: Collections.CHAMPIONSHIPS,
            doc: id || "-1",
        }) || ChampionshipDefaultValues;

    const onSubmit = useOnSubmitFormik<Championship>(
        Collections.CHAMPIONSHIPS,
        {
            callback: (id) => {
                if (championship && !championship.id) {
                    history.push(`/championship/${id}`);
                }
            },
        }
    );

    const { isDownMd } = useThemeBreakpoints();

    return (
        <PageLayout
            title={`Campeonato - (${championship.name})`}
            showInBoxCard={false}
            boxCardProps={{
                marginBottom: "60px",
            }}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Tabs
                        variant={isDownMd ? "scrollable" : "fullWidth"}
                        centered={!isDownMd}
                        indicatorColor="primary"
                        textColor="primary"
                        scrollButtons="on"
                        value={selectedTab}
                        onChange={selectTab(setSelectedTab)}
                    >
                        <Tab
                            label="Detalhes"
                            value="details"
                            style={{ fontSize: "0.85rem" }}
                        />
                        <Tab
                            label="Carros"
                            value="cars"
                            style={{ fontSize: "0.85rem" }}
                        />
                        <Tab
                            label="Baterias"
                            value="races"
                            style={{ fontSize: "0.85rem" }}
                        />
                        <Tab
                            label="Etapas"
                            value="rounds"
                            style={{ fontSize: "0.85rem" }}
                        />
                        <Tab
                            label={`Pilotos`}
                            value="drivers"
                            style={{ fontSize: "0.85rem" }}
                        />
                        <Tab
                            label="Pontuação"
                            value="pointing"
                            style={{ fontSize: "0.85rem" }}
                        />
                    </Tabs>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Formik
                        enableReinitialize={true}
                        initialValues={{
                            ...ChampionshipDefaultValues,
                            ...championship,
                        }}
                        validationSchema={ChampionshipValidation}
                        onSubmit={onSubmit}
                    >
                        {({ values, dirty }) => {
                            return (
                                <Form>
                                    <Prompt
                                        when={dirty && !!values.id}
                                        message="Exitem alterações não salvas, tem certeza que deseja deixar a página?"
                                    />
                                    <Grid container spacing={1}>
                                        <Grid
                                            item
                                            xs={12}
                                            hidden={selectedTab !== "details"}
                                        >
                                            <BoxCard>
                                                <ChampionshipDetails />
                                            </BoxCard>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            hidden={selectedTab !== "cars"}
                                        >
                                            <BoxCard>
                                                <ChampionshipCars />
                                            </BoxCard>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            hidden={selectedTab !== "races"}
                                        >
                                            <BoxCard>
                                                <RaceConfigurationList
                                                    championship={values}
                                                    configurations={
                                                        values.raceConfigurations
                                                    }
                                                />
                                            </BoxCard>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            hidden={selectedTab !== "drivers"}
                                        >
                                            <BoxCard>
                                                {values.id ? (
                                                    <DriverConfiguration />
                                                ) : (
                                                    <Message
                                                        show
                                                        variant="info"
                                                        message="É necessário salvar o campeonato antes de adicionar um piloto"
                                                    />
                                                )}
                                            </BoxCard>
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        hidden={selectedTab !== "pointing"}
                                    >
                                        <BoxCard marginTop={1}>
                                            <ChampionshipPointingForm />
                                        </BoxCard>
                                    </Grid>
                                    <FixedBottomBar>
                                        <SubmitButton />
                                    </FixedBottomBar>
                                </Form>
                            );
                        }}
                    </Formik>
                </Grid>
                <Grid item xs={12} hidden={selectedTab !== "rounds"}>
                    <BoxCard>
                        {id ? (
                            <RoundList
                                championshipId={id}
                                seasonId={championship?.seasonId || "-1"}
                            />
                        ) : (
                            <Message
                                show
                                variant="info"
                                message="É necessário salvar o campeonato antes de adicionar uma etapa"
                            />
                        )}
                    </BoxCard>
                </Grid>
            </Grid>
        </PageLayout>
    );
};

export { ChampionshipForm };
export default ChampionshipForm;
